module.exports = __webpack_public_path__ + "static/LogoRGB-79b8584a478fb19a46f156d1e2bd7718.png";